import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
	appCreateSponsor,
	appDeleteSponsor,
	appGetAllSponsor,
	appUpdateSponsor,
	uploadSponsorImage,
} from '../../store/sponsor'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Paginate from '../pagination/paginate'
import Select from 'react-select'
import ImageUpload from '../ImageUpload'
import swal from 'sweetalert'
import PostPreview from '../PostPreview/PostPreview'
import ExportButton from '../../common/ExportButton'
import { sponsorExportColumns } from '../../config/exportColumns/sponsorExportColumns'
import { appAllGetPaymentSettings } from '../../store/paymentsetting'
import { toCamelCase } from '../../utils/Function'

function Sponsor({
	sansthaDetails,
	hubDetails,
	users,
	hideSansthaField,
	isHubPage,
	sponsor,
	sponsorList,
	setSponsorPage,
	sponsorpage,
}) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const params = useParams()
	const { id } = useParams()
	const [showSponsorModal, setShowSponsorModal] = useState(false)
	const [editSponsorMode, setEditSponsorMode] = useState(false)
	const [editSponsorId, setEditSponsorId] = useState(null)
	const [startDate, setStartDate] = useState(new Date())
	const [endDate, setEndDate] = useState(
		new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
	)
	const sponsorpaginate = useSelector(state => state.sponsorReducer.paginate)
	const payment = useSelector(state => state.paymentSettingsReducer.payment)

	const sponsorValidationSchema = Yup.object({
		image: Yup.string()
			.required('Image is required')
			.test('is-valid-url', 'Invalid image', value => {
				return value && value !== '/img/default-placeholder.jpg'
			}),

		user: Yup.string().required('User is required'),
	})

	useEffect(() => {
		dispatch(appAllGetPaymentSettings())
	}, [dispatch])

	const allCommunityFee = payment?.allcommunity || 0
	const communityFee = payment?.community?.price || 0
	const sansthaFee = payment?.sanstha?.price || 0

	const sponsorFormik = useFormik({
		initialValues: {
			// name: '',
			description: '',
			sanstha: id,
			hub: '',
			image: '',
			user: '',
			startDate: '',
			endDate: '',
			sponsorDate: '',
			sponsorfee: '',
			note: '',
		},
		validationSchema: sponsorValidationSchema,
		onSubmit: values => {
			//	console.log(values)
			const temp_obj = {
				// name: values?.name,
				image: values?.image,

				hub: typeof values?.hub === 'object' ? values?.hub._id : values?.hub,
				user: values?.user,
				startDate: values.startDate,
				endDate: values.endDate,
				description: values?.description,
				sponsorDate: values?.sponsorDate,
				sponsorfee: values?.sponsorfee,
				amount: values.sponsorfee,
				note: values?.note,
				navigate: navigate,
			}

			if (!isHubPage) {
				temp_obj.sanstha =
					typeof values?.sanstha === 'object' ? values?.sanstha._id : values?.sanstha
			}
			const filtered_obj = Object.fromEntries(
				Object.entries(temp_obj).filter(
					([key, value]) =>
						value !== '' && value !== null && value !== undefined && key !== 'navigate',
				),
			)
			filtered_obj.navigate = navigate

			if (editSponsorMode && editSponsorId) {
				dispatch(appUpdateSponsor({ ...filtered_obj, id: editSponsorId })).then(() => {
					if (isHubPage && hubDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								hub: hubDetails?._id,
								admin: true,
							}),
						)
					} else if (!isHubPage && sansthaDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								sanstha: sansthaDetails?._id,
							}),
						)
					}
				})
			} else {
				dispatch(appCreateSponsor(filtered_obj)).then(() => {
					if (isHubPage && hubDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								hub: hubDetails?._id,
								admin: true,
							}),
						)
					} else if (!isHubPage && sansthaDetails?._id) {
						dispatch(
							appGetAllSponsor({
								page: 1,
								limit: 10,
								sanstha: sansthaDetails?._id,
							}),
						)
					}
				})
			}

			setShowSponsorModal(false)
			setEditSponsorMode(false)
			setEditSponsorId(null)
			sponsorFormik.resetForm()
		},
	})

	const handleEditSponsor = sponsor => {
		setEditSponsorMode(true)
		setEditSponsorId(sponsor._id)
		setShowSponsorModal(true)
		sponsorFormik.setValues({
			// name: sponsor.name,
			description: sponsor.description,
			hub: hubDetails?._id,
			sanstha: id,
			image: sponsor.image,
			user: sponsor.user._id,
			sponsorDate: sponsor.sponsorDate,
			sponsorfee: sponsor.sponsorfee,
			note: sponsor.note,
		})
		if (sponsor?.startDate) {
			const date = new Date(sponsor.startDate)
			setStartDate(date)
			sponsorFormik.setFieldValue('startDate', date.toISOString().split('T')[0])
		}
		if (sponsor?.endDate) {
			const date = new Date(sponsor.endDate)
			setEndDate(date)
			sponsorFormik.setFieldValue('endDate', date.toISOString().split('T')[0])
		}
	}

	const handleAddNewSponsor = () => {
		setEditSponsorMode(false)
		setEditSponsorId(null)

		const today = new Date()
		const nextYear = new Date()
		nextYear.setFullYear(today.getFullYear() + 1)

		const start = today.toISOString().split('T')[0]
		const end = nextYear.toISOString().split('T')[0]

		sponsorFormik.resetForm()
		sponsorFormik.setValues({
			description: '',
			hub: hubDetails?._id,
			sanstha: id,
			image: '',
			user: '',
			sponsorDate: '',
			sponsorfee: '',
			note: '',
			startDate: start,
			endDate: end,
		})

		setStartDate(today)
		setEndDate(nextYear)

		setShowSponsorModal(true)
	}
	const handleDeleteSponsor = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this sponsor?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteSponsor(id))
			}
		})
	}

	useEffect(() => {
		let fee = 0

		// const hasSanstha = !!sponsorFormik.values.sanstha
		// const hasCommunity = !!sponsorFormik.values.hub

		// if (hasSanstha && hasCommunity) {
		// 	fee = communityFee
		// } else if (hasSanstha) {
		// 	fee = sansthaFee
		// } else {
		// 	fee = allCommunityFee
		// }

		if (isHubPage) {
			fee = communityFee
		} else {
			fee = sansthaFee
		}

		sponsorFormik.setFieldValue('sponsorfee', fee)
	}, [
		sponsorFormik.values.sanstha,
		sponsorFormik.values.hub,
		communityFee,
		sansthaFee,
		allCommunityFee,
	])

	return (
		<div>
			<div className="mb-3 mr-2 d-flex justify-content-between align-items-center">
				<h4 className="ml-2">Total Sponsors: {sponsorList?.length || 0}</h4>

				<div className="d-flex gap-2">
					<ExportButton
						fetchAction={params =>
							dispatch(
								appGetAllSponsor({
									...params,
									page: 1,
									limit: 100000,
									...(isHubPage &&
										hubDetails?._id && {
											hub: hubDetails._id,
											admin: true,
										}),
									...(!isHubPage &&
										sansthaDetails?._id && {
											sanstha: sansthaDetails._id,
										}),
									loading: false,
								}),
							)
						}
						columns={sponsorExportColumns}
						fileName="Sponsors"
						sheetName="Sponsors"
						buttonText="Export Sponsors"
					/>

					<button
						style={{ marginLeft: '10px' }}
						className="btn btn-primary"
						onClick={handleAddNewSponsor}
					>
						<i className="far fa-plus"></i> Add New Sponsor
					</button>
				</div>
			</div>

			<div className="table-responsive">
				<table className="table table-bordered table-hover">
					<thead className="">
						<tr>
							<th>Sr. No.</th>
							<th>Sponsor</th>
							<th>User</th>
							<th>Duration</th>
							<th>Recived Amount (Rs)</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{sponsor?.length > 0 ? (
							sponsor.map((sponsor, index) => (
								<tr key={index}>
									<td>{index + 1 + (sponsorpage - 1) * 10}</td>
									<td>
										<PostPreview value={sponsor.image} />
										{sponsor?.name}{' '}
									</td>
									<td>
										{sponsor?.user?.firstName} {sponsor?.user?.lastName}
									</td>
									<td>
										{' '}
										{new Date(sponsor?.startDate).toLocaleDateString('en-US', {
											year: 'numeric',
											month: 'short',
											day: 'numeric',
										})}{' '}
										-{' '}
										{new Date(sponsor?.endDate).toLocaleDateString('en-US', {
											year: 'numeric',
											month: 'short',
											day: 'numeric',
										})}
									</td>
									<td>{sponsor?.amount || 0}</td>
									<td>
										<button
											className="btn btn-sm btn-primary mr-2"
											title="Edit"
											onClick={() => handleEditSponsor(sponsor)}
										>
											<i className="far fa-edit"></i>
										</button>
										<button
											className="btn btn-sm btn-danger"
											title="Delete"
											onClick={() => handleDeleteSponsor(sponsor?._id)}
										>
											<i className="far fa-trash-alt"></i>
										</button>
									</td>
								</tr>
							))
						) : (
							<tr>
								<td colSpan="7" className="text-center">
									No sponsors data available
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{sponsorpaginate && (
				<Paginate paginate={sponsorpaginate} page={sponsorpage} setPage={setSponsorPage} />
			)}

			{showSponsorModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog modal-lg">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">
									{editSponsorMode ? 'Edit Sponsor' : 'Create New Sponsor'}
								</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowSponsorModal(false)
										setEditSponsorMode(false)
										setEditSponsorId(null)
										sponsorFormik.resetForm()
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={sponsorFormik.handleSubmit}>
									<div className="row">
										{!hideSansthaField && (
											<div className="col-md-6">
												<div className="form-group">
													<label>Sanstha *</label>
													<Select
														name="_id"
														options={[
															{
																value: id,
																label: sansthaDetails?.name,
															},
														]}
														onChange={option => {
															sponsorFormik.setFieldValue('sanstha', option?.value)
														}}
														className="basic-multi-select"
														classNamePrefix="select"
														value={[
															{
																value: id,
																label: sansthaDetails?.name,
															},
														]}
														placeholder="Select.."
														isDisabled={true}
													/>
													{sponsorFormik.touched.hub && sponsorFormik.errors.hub ? (
														<div style={{ color: 'red' }}>{sponsorFormik.errors.hub}</div>
													) : null}
												</div>
											</div>
										)}
										<div className="col-md-6">
											<div className="form-group">
												<label>Sponsored on Community level *</label>
												<Select
													name="_id"
													options={[
														{
															value: hubDetails?._id,
															label: toCamelCase(hubDetails?.name),
														},
													]}
													onChange={option => {
														sponsorFormik.setFieldValue('hub', option?.value)
													}}
													className="basic-multi-select"
													classNamePrefix="select"
													value={{
														value: hubDetails?._id,
														label: toCamelCase(hubDetails?.name) || 'No Hub Name',
													}}
													placeholder="Select.."
													isDisabled={true}
												/>
												{sponsorFormik.touched.hub && sponsorFormik.errors.hub ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.hub}</div>
												) : null}
											</div>
										</div>

										<div className="col-md-6">
											<ImageUpload
												uploadFunction={uploadSponsorImage}
												fieldName="image"
												value={sponsorFormik.values.image}
												onChange={value => sponsorFormik.setFieldValue('image', value.url)}
												error={
													sponsorFormik.touched.image && sponsorFormik.errors.image
														? sponsorFormik.errors.image
														: null
												}
											/>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Select Users</label>
												<Select
													options={
														Array.isArray(users)
															? users.map(user => ({
																	value: user._id,
																	label: `${user.firstName} ${user.lastName || ''} (${user.mobile ||
																		''})`,
															  }))
															: []
													}
													onChange={option => {
														sponsorFormik.setFieldValue('user', option?.value)
														sponsorFormik.setFieldTouched('user', true)

														const selectedUser = Array.isArray(users)
															? users.find(u => u._id === option?.value)
															: null

														if (selectedUser) {
															sponsorFormik.setFieldValue('name', selectedUser.firstName)
														}
													}}
													onBlur={() => sponsorFormik.setFieldTouched('user', true)}
													value={
														Array.isArray(users)
															? users
																	.filter(user => user._id === sponsorFormik.values.user)
																	.map(user => ({
																		value: user._id,
																		label: `${user.firstName} ${user.lastName ||
																			''} (${user.mobile || ''})`,
																	}))[0] || null
															: null
													}
													placeholder="Select User..."
												/>
												{sponsorFormik.touched.user && sponsorFormik.errors.user ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.user}</div>
												) : null}
											</div>
										</div>

										{/* <div className="col-md-6">
											<div className="form-group">
												<label>Name *</label>
												<input
													className="form-control"
													name="name"
													type="text"
													onChange={sponsorFormik.handleChange}
													onBlur={sponsorFormik.handleBlur}
													value={sponsorFormik.values.name}
												/>
												{sponsorFormik.touched.name && sponsorFormik.errors.name ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.name}</div>
												) : null}
											</div>
										</div> */}

										<div className="col-md-6">
											<div className="form-group">
												<label>Date of offline payment received</label>

												<input
													type="date"
													className="form-control"
													value={sponsorFormik.values.sponsorDate || ''}
													onChange={e => {
														const rawValue = e.target.value
														if (!rawValue) {
															sponsorFormik.setFieldValue('sponsorDate', '')
															return
														}

														const dateObj = new Date(rawValue)
														if (isNaN(dateObj.getTime())) return

														sponsorFormik.setFieldValue('sponsorDate', rawValue)
													}}
												/>
												{sponsorFormik.touched.sponsorDate && sponsorFormik.errors.sponsorDate ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.sponsorDate}</div>
												) : null}
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Sponsor Fee </label>
												<input
													type="number"
													className="form-control"
													name="sponsorfee"
													value={sponsorFormik.values.sponsorfee}
													readOnly
													// onChange={sponsorFormik.handleChange}
													// onBlur={sponsorFormik.handleBlur}
												/>
											</div>
										</div>
									</div>

									<div className="row" style={{ padding: '0 0 15px 0' }}>
										<div className="col-md-6">
											<div className="form-group">
												<label>Start Date </label>
												<input
													type="date"
													className="form-control"
													value={sponsorFormik.values.startDate || ''}
													onChange={e => {
														if (!e.target.value) {
															sponsorFormik.setFieldValue('startDate', '')
															sponsorFormik.setFieldValue('endDate', '')
															setStartDate(null)
															setEndDate(null)
															return
														}
														const dateValue = new Date(e.target.value)
														if (isNaN(dateValue.getTime())) {
															return
														}
														setStartDate(dateValue)
														let dateOnly = dateValue.toISOString().split('T')[0]
														sponsorFormik.setFieldValue('startDate', dateOnly)

														const nextYear = new Date(dateValue)
														nextYear.setFullYear(nextYear.getFullYear() + 1)
														setEndDate(nextYear)
														sponsorFormik.setFieldValue(
															'endDate',
															nextYear.toISOString().split('T')[0],
														)
													}}
												/>
											</div>
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>End Date </label>
												<input
													type="date"
													className="form-control"
													value={sponsorFormik.values.endDate || ''}
													readOnly
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Notes (payment details and received by) </label>
												<textarea
													className="form-control"
													name="note"
													onChange={sponsorFormik.handleChange}
													onBlur={sponsorFormik.handleBlur}
													value={sponsorFormik.values.note}
													rows="3"
												/>
											</div>
										</div>
										{/* <div className="col-md-12">
											<div className="form-group">
												<label>Description *</label>
												<textarea
													className="form-control"
													name="description"
													onChange={sponsorFormik.handleChange}
													onBlur={sponsorFormik.handleBlur}
													value={sponsorFormik.values.description}
													rows="3"
												/>
												{sponsorFormik.touched.description && sponsorFormik.errors.description ? (
													<div style={{ color: 'red' }}>{sponsorFormik.errors.description}</div>
												) : null}
											</div>
										</div> */}
									</div>
									<div className="modal-footer">
										<button className="btn btn-labeled btn-success" type="submit">
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editSponsorMode ? 'Update' : 'Create'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowSponsorModal(false)
												setEditSponsorMode(false)
												setEditSponsorId(null)
												sponsorFormik.resetForm()
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}
export default Sponsor
